import React, { Component } from 'react'
import { apiProcess } from '../../../api/api'
import {
  trackEmailConfirmationResent,
  trackEmailConfirmationResentAttempt,
} from '../../../elements/tracking/accountTracking.js'
import { Header, Button } from '../../../elements'
import { EMAIL } from 'components/account/infoWizard/main/constants'

class EmailAuthScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      sendError: false,
    }
  }

  componentDidMount() {
    this.props.onScreenLoad(EMAIL)
    if (this.props.sendEmailOnLoad) {
      this.resendEmailConf()
    }
  }

  resendEmailConf = () => {
    let apiURL = 'users/validations/resend_email_token'

    this.setState({
      loading: true,
      sendError: false,
    })

    apiProcess(apiURL, false, 'resend-verf-email', 'Resend Email Component')
      .then((responseData) => {
        this.setState({ loading: false })
        trackEmailConfirmationResent({
          parent: this.props.parentDescription,
        })
        this.props.onSuccess()
      })
      .catch((responseData) => {
        this.setState({
          loading: false,
          sendError: true,
        })
        trackEmailConfirmationResentAttempt({
          parent: this.props.parentDescription,
          error_message: 'Sorry, please try again.',
          error_code: responseData.code,
          error_type: 'Submission - Server',
        })
        this.props.onAttempt({
          error_message: 'Sorry, please try again.',
          attempt_desc: 'Resend Email',
          error_code: responseData.code,
          error_type: 'Submission - Server',
        })
      })
  }

  handleButtonClick = () => {
    this.props.onSuccess()
    this.props.onComplete()
  }

  render() {
    return (
      <div className="has-text-centered">
        {this.props.header && (
          <Header renderAs="h2" size={4} className="has-text-weight-extra-bold mb-1">
            {this.props.header}
          </Header>
        )}
        {this.props.instructions && <p className="mb-4">{this.props.instructions}</p>}
        {
          //<Icon circular name='mail outline' size="big" /><br /><br />
        }
        <Button color="primary" onClick={this.handleButtonClick} className="mb-4">
          {this.props.buttonText}
        </Button>
        <br />
        <Button
          size="small"
          loading={this.state.loading}
          disabled={this.state.loading}
          onClick={() => this.resendEmailConf()}
        >
          Resend Email
        </Button>
        {this.state.sendError && <div className="has-text-danger">Please try again.</div>}
      </div>
    )
  }
}

export default EmailAuthScreen

EmailAuthScreen.defaultProps = {
  emailAddress: 'the address associated with your account.',
  header: 'Check your email!',
  instructions: 'Tap the link in the email we sent you to confirm your email address.',
  showButton: true,
  skippable: true,
  onSuccess: function() {},
  buttonText: 'Got It!',
  onAttempt: function() {},
  parentDescription: 'Missing',
  onScreenLoad: function() {},
  sendEmailOnLoad: false,
  onComplete: () => {},
}
